import React from 'react'
import ReactDOM from 'react-dom/client'
import './utils/dayjs'
import { App as AntApp, ConfigProvider } from 'antd'
import App from './App'
import './index.css'

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element not found')

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#2563eb',
          borderRadius: 6,
          colorBorderSecondary: '#e8e8e8',
          colorSplit: '#e8e8e8',
        },
      }}
    >
      <AntApp>
        <App />
      </AntApp>
    </ConfigProvider>
  </React.StrictMode>,
)
